import React from 'react'
import Link from 'next/link'

const CategoriaCard = ({ main_image, titolo, slug }) => {
  return (
    <Link legacyBehavior href={slug ? slug : ''}>
      <a className="categoria">
        <div className="categoria__content">
          <div className="categoria__content__image-box">
            {main_image && <img src={main_image} className="categoria__content__image" />}
          </div>
          <p className="categoria__content__titolo">{titolo}</p>
        </div>
      </a>
    </Link>
  )
}

export default CategoriaCard
